import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ApiVisa } from 'blg-akaun-ts-lib';
import { SessionActions } from '../../modules/session/session-controller/actions';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { SessionStates } from '../../modules/session/session-controller/states';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { DropDownService } from "../../services/drop-down-service";
import { SharedUtilitiesHelperFunctions } from '../helper-functions';

@Component({
  selector: 'app-select-multi-location-label-drop-down',
  templateUrl: './select-multi-location-label-drop-down.component.html',
  styleUrls: ['./select-multi-location-label-drop-down.component.css']
})
export class SelectMultiLocationLabelDropDownComponent implements OnInit, OnDestroy {

  @Input() locationLabel: FormControl;
  @Input() apiVisa: ApiVisa;
  @Input() selectedGuid: string;
  @Input() label = 'Location Label';
  @Input() options: any;

  @Output() locationLabelSelected = new EventEmitter<any>();

  serverSideFiltering = new FormControl();
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  selectedRow: any;
  rowData: any = [];
  key = "locationLabel";
  allSelected = false;
  filteredCache: any = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;
  
  protected _onDestroy = new Subject<void>();

  constructor(private dropDownService: DropDownService,
    private readonly store: Store<SessionStates>
  ) { }

  ngOnInit() {
    // set initial selection
    this.store.select(SessionSelectors.selectDropDownRowData).subscribe(resolved => {
      this.rowData = resolved?resolved[this.key]?resolved[this.key]:[]:[];
      if (this.rowData.length === 0) {
        this.getRowData();
      }
      else {
        this.filteredOptions$.next(this.rowData.slice());
      }
    })

    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtering();
      });

     // listen for multi select field value changes
     this.locationLabel.valueChanges
      .pipe(takeUntil(this._onDestroy)).subscribe(() => {
       this.setToggleAllCheckboxState();
     });  
  }

  ngOnChanges() {
    console.log('ngOnChanges');
  }

  getRowData(keyword?: string) {
    const formData = {
      "keyword" : ( keyword ? keyword : ''),
      limit: "",
      orderBy: "name",
      order: "ASC",
    };
    this.dropDownService
      .get("location-label/backoffice-ep", formData, this.apiVisa)
      .subscribe((resolved) => {
        this.rowData = [...this.rowData, ...resolved.data];
        this.rowData = SharedUtilitiesHelperFunctions.removeDuplicate(this.rowData, "guid");
        this.rowData = this.rowData.filter((entity) => entity.name !== ""); // remove locations with no name

        this.store.dispatch(
          SessionActions.selectDropDownRowData({
            key: this.key,
            rowData: this.rowData,
          })
        );

        if (keyword) {
          this.filteredOptions$.next(resolved.data.slice());
        } else {
          this.filteredOptions$.next(this.rowData.slice());
        }
      });
  }

  filtering() {
    if (!this.rowData) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.rowData.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the LocationLabels
    this.filteredOptions$.next(
      this.rowData.filter((option) =>
        (option.code ?
          option.code.toLowerCase().indexOf(search) > -1 : null) ||
        (option.name ?
          option.name.toLowerCase().indexOf(search) > -1 : null))
    );
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredOptions$.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(val => {
        if (selectAllValue) {
          if (this.isSelectObject()) {
            this.locationLabel.patchValue(val);
          }
          else {
            this.locationLabel.patchValue([...val.map(item => item.guid)]);
          }
        } else {
          this.locationLabel.patchValue([]);
        }
      }
    );
  }

  onSelect(guid: string) {
    if (guid) {
      this.locationLabel.patchValue(guid);
      this.selectedRow = this.rowData.find(row => row.guid === guid);
      this.locationLabelSelected.emit(this.selectedRow);
    }
  }

  isRequired() {
    let value = this.options['required'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false; 
  }

  isMultiple() {
    let value = this.options['multiple'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false; 
  }

  setToggleAllCheckboxState() {
    if (!this.isMultiple()) return;
    let filteredLength = 0;
    if (this.locationLabel && this.locationLabel.value) {
      this.filteredCache.forEach(el => {
        if (this.locationLabel.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate = filteredLength > 0 && filteredLength < this.filteredCache.length;
      this.isChecked = filteredLength > 0 && filteredLength === this.filteredCache.length;
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  isSelectObject() {
    let value = this.options['selectObject'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false;
  }

  showValue(option) {
    if (this.isSelectObject()) {
      return option;
    }
    else {
      return option.guid;
    }
  }

}
